import React, { FC } from 'react';
import { Asset, Button, YesIcon } from '@clearcover/atlas';
import { Column, Row } from 'Shared/components';
import { ReportStatus } from '../types';
import styles from './styles.module.css';
import { ReportChangeMessageType, ReportMessages } from '../ReportMessages';
import { RateChangeModalData } from '../useReportRunner';
import RateChangeModal from './RateChangeModal/RateChangeModal';

type ReportType = {
  displayName: string;
  messages: Array<ReportChangeMessageType>;
  enabled: boolean;
  status: ReportStatus;
  onClick(): void;
  type: string;
  buttonLabel?: string;
  preRunLabel?: React.ReactNode;
  showRateChangeModal?: boolean;
  setShowRateChangeModal?: (show: boolean) => void;
  rateChangeModalData?: RateChangeModalData;
};

export const Report: FC<ReportType> = ({
  displayName,
  messages,
  enabled,
  status,
  onClick,
  type,
  buttonLabel,
  preRunLabel,
  showRateChangeModal,
  setShowRateChangeModal,
  rateChangeModalData,
}) => {
  const hasProductToggle = messages.some(
    (message) => message.messageType === 'product-toggle'
  );
  const showMessages =
    status === 'completed' || status === 'error' || hasProductToggle;

  return (
    <div className={styles.reportItem} data-testid={`${type}-report`}>
      <Row className={styles.row}>
        <Column variant="half">
          <div className={styles.nameSection}>
            <div className={styles.reportName}>{displayName}</div>
          </div>
        </Column>
        <Column variant="half" className={styles.lastColumn}>
          {status === ReportStatus.Ready && preRunLabel}
          <div className={styles.action}>
            {status === ReportStatus.Completed ? (
              <div
                className={styles.icon}
                data-testid={`report-success-${type}`}
              >
                <Asset
                  icon={YesIcon}
                  height={14}
                  width={14}
                  description="success icon"
                />
                <div className={styles.message}>Success</div>
              </div>
            ) : (
              <Button
                data-testid={`run-report-${type}`}
                size="sm"
                disabled={!enabled || hasProductToggle}
                variant="primary"
                isSubmitting={status === ReportStatus.Pending}
                onClick={onClick}
              >
                {buttonLabel || 'Run Reports'}
              </Button>
            )}
          </div>
        </Column>
      </Row>
      {showMessages && <ReportMessages messages={messages} />}
      <RateChangeModal
        open={showRateChangeModal || false}
        onClose={() => {
          setShowRateChangeModal?.(false);
        }}
        rateChangeModalData={rateChangeModalData || null}
        reportName={displayName}
      />
    </div>
  );
};
